import { Box, Card, Typography, Switch, FormControlLabel, TextField, useTheme } from "@mui/material";
import MetricCard from "./MetricCard";

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(value);

const SimulationPanel = ({
  investmentAmount,
  onAmountChange,
  simulationEnabled,
  onToggleSimulation,
  isSimulationActive,
  projectedValue,
  dollarReturn,
}) => {
  const theme = useTheme();

  return (
    <Card sx={{
      p: 3,
      display: "flex",
      flexDirection: "column",
      gap: 2,
      borderRadius: 2,
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      border: `1px solid ${theme.palette.divider}`,
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h4">
          Simulate Investment
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={simulationEnabled}
              onChange={(e) => onToggleSimulation(e.target.checked)}
            />
          }
          label={simulationEnabled ? "On" : "Off"}
          labelPlacement="start"
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          opacity: simulationEnabled ? 1 : 0.4,
          pointerEvents: simulationEnabled ? "auto" : "none",
          transition: "opacity 0.2s ease",
        }}
      >
        <TextField
          label="Investment Amount"
          type="number"
          value={investmentAmount}
          onChange={(e) => {
            if (e.target.value.length <= 16) onAmountChange(e.target.value);
          }}
          placeholder="0.00"
          fullWidth
          disabled={!simulationEnabled}
          onKeyDown={(e) => { if (e.key === "-") e.preventDefault(); }}
          slotProps={{ input: { inputMode: "decimal", min: 0 } }}
        />

        <MetricCard
          title="Projected Value"
          value={isSimulationActive ? formatCurrency(projectedValue) : "—"}
          color="text.primary"
        />
        <MetricCard
          title="Dollar Return"
          value={isSimulationActive ? formatCurrency(dollarReturn) : "—"}
          color={isSimulationActive ? (dollarReturn >= 0 ? "success.main" : "error.main") : "text.secondary"}
        />
      </Box>
    </Card>
  );
};

export default SimulationPanel;
